<template>
  <div class="electronic-over-view">
    <!--    <el-tabs type="card" v-model="buildingOnPage">-->
    <!--<el-tab-pane v-for="buildItem in buildingList" :label="buildItem.name" :name="buildItem.code" :key="buildItem.code">-->

    <!--</el-tab-pane>-->
    <div class="electronic-over-view-line" style="margin-bottom: 0.12rem">
      <div class="electronic-person-count-box" style="background:linear-gradient(to right, rgba(52, 147, 235, .8), rgba(54, 212, 233, .8));">
        <div class="electronic-person-count-box-info" style="display: flex;justify-content: space-between;align-items: center;">
          <div style="flex: 1">
            <div class="electronic-person-tip">电表总数</div>
            <div class="electronic-person-count">{{electricMeterTotalCount || 0}}<span style="font-size: 0.08rem">(个)</span></div>
          </div>
        </div>
        <!--        <i class="el-icon-damai-dianbiaolixianshuaibaobiao"></i>-->
        <img src="../../../assets/smart_electricity/electricity_total.png" alt="">
      </div>
      <div class="electronic-person-count-box" style="background: linear-gradient(to right, rgb(240, 152, 25, .8), rgb(237, 222, 93, .8));">
        <!--        <i class="el-icon-damai-dianbiaolixianshuaibaobiao"></i>-->
        <div class="electronic-person-count-box-info" style="display: flex;justify-content: space-between;align-items: center;">
          <div style="flex: 1">
            <div class="electronic-person-tip">离线电表</div>
            <div class="electronic-person-count"><span :style="{color: electricMeterOffCount ? 'red' : '#fff'}">{{electricMeterOffCount || 0}}</span><span style="font-size: 0.08rem">(个)</span></div>
          </div>
        </div>
        <img src="../../../assets/smart_electricity/electricity_leave.png" alt="">
      </div>
      <div class="electronic-person-count-box" style="background:linear-gradient(to right, rgb(255, 121, 121, .8), rgb(255, 167, 209, .8))">
        <!--        <i class="el-icon-damai-shebei2"></i>-->
        <div class="electronic-person-count-box-info" style="display: flex;justify-content: space-between;align-items: center;">
          <div style="flex: 1">
            <div class="electronic-person-tip">集中器总数</div>
            <div class="electronic-person-count">{{electricManagerTotalCount || 0}}<span style="font-size: 0.08rem">(台)</span></div>
          </div>
        </div>
        <img src="../../../assets/smart_electricity/concentrator_total.png" alt="">
      </div>
      <div class="electronic-person-count-box" style="background:linear-gradient(to right, rgb(191, 112, 251, .8), rgb(156, 189, 255, .8))">
        <!--        <i class="el-icon-damai-shebei2"></i>-->
        <div class="electronic-person-count-box-info" style="display: flex;justify-content: space-between;align-items: center;">
          <div style="flex: 1">
            <div class="electronic-person-tip">离线集中器</div>
            <div class="electronic-person-count"><span :style="{color: electricManagerOffCount ? 'red' : '#fff'}">{{electricManagerOffCount || 0}}</span><span style="font-size: 0.08rem">(台)</span></div>
          </div>
        </div>
        <img src="../../../assets/smart_electricity/concentrator_leave.png" alt="">
      </div>
      <div class="electronic-person-count-box" style="background:linear-gradient(to right, rgb(83, 107, 248, .8), rgb(38, 208, 206, .8))">
        <!--        <i class="el-icon-damai-liuliang"></i>-->
        <div class="electronic-person-count-box-info">
          <div class="electronic-person-tip">当月电量</div>
          <div class="electronic-person-count" style="font-size: 0.15rem">{{electricQuantityTitle || 0}}<span class="electronic-person-count-unit">(度)</span></div>
        </div>
        <img src="../../../assets/smart_electricity/electricity_num.png" alt="">
      </div>
      <div class="electronic-person-count-box" style="background:linear-gradient(to right, rgb(51, 201, 96, .8), rgb(43, 205, 205, .8))">
        <!--        <i class="el-icon-damai-yingshoujine"></i>-->
        <div class="electronic-person-count-box-info">
          <div class="electronic-person-tip">当月电费</div>
          <div class="electronic-person-count" style="font-size: 0.15rem">{{electricFeiTitle || 0}}<span class="electronic-person-count-unit">(元)</span></div>
        </div>
        <img src="../../../assets/smart_electricity/electricity_charge.png" alt="">
      </div>
    </div>

    <!--      <div class="electronic-over-view-line" style="margin-bottom: 20px">-->
    <!--        <div class="electronic-over-view-line-left">-->
    <!--          <ammeter-pie :buildingCode="buildingOnPage" />-->
    <!--          <controller-pie :buildingCode="buildingOnPage" />-->
    <!--        </div>-->
    <!--        <div class="electronic-over-view-line-right">-->
    <!--          <div style="width: 50%;padding: 20px 0;">-->
    <!--            <common-ring commonRingId="electricQuantityRing" :height="'240px'" :colorList="commonColorList" :ringLegend="commonRingLegend" :ringTitle='electricQuantityTitle' :ringData='electricQuantityInfo' />-->
    <!--          </div>-->
    <!--          <div style="width: 50%;padding: 20px 0;">-->
    <!--            <common-ring commonRingId="electricFeiRing" :height="'240px'" :colorList="commonColorList" :ringLegend="commonRingLegend" :ringTitle='electricFeiTitle' :ringData='electricFeiInfo' />-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->

    <div class="electronic-over-view-line" style="margin-bottom: 0.12rem;padding: 0.12rem;position: relative;border-radius: 0.06rem;background-color: #fff;">
      <h2>级别电量统计</h2>
      <chart-time-select @getData="getEelectricityLevleStatistics" style="right: 0.14rem;top: 7.5%" />
      <common-line
        style="z-index: 1000"
        lineId='electricityLevelLine'
        legendRight="478px"
        legendTop="2.7%"
        gridLeft="1.7%"
        :height='"1.73rem"'
        :legendTextStyle="legendTextStyle"
        :legendData="electricityLevelLegendData"
        :xAxis="electricityLevelXAxis"
        :yAxis='electricityLevelYAxis'
        :series='electricityLevelSeries'
      />
    </div>

    <div class="electronic-over-view-line" style="margin-bottom: 0.12rem;padding: 0.12rem;position: relative;border-radius: 0.06rem;background-color: #fff;">
      <!--<electronic-month-stacking-bar :buildingCode="buildingOnPage" />-->
      <h2>场景电量统计</h2>
      <chart-time-select @getData="getEelectricityStatistics" style="right: 0.14rem;top: 7.5%" />
      <common-line
        style="z-index: 1000"
        lineId='electricityLine'
        :height='"1.73rem"'
        legendRight="478px"
        legendTop="2.7%"
        gridLeft="1.7%"
        legend-type="scroll"
        legendWidth="50%"
        :legendTextStyle="legendTextStyle"
        :legendData="electricityLegendData"
        :xAxis="electricityXAxis"
        :yAxis='electricityYAxis'
        :series='electricitySeries' />
    </div>

    <!--      <div class="electronic-over-view-line" style="margin-bottom: 20px;border: 1px solid #DCDFE6;-->
    <!--        box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);padding: 10px 10px;position: relative;">-->
    <!--        <div style="position: absolute;top: 15px;right: 0;left: 0;margin: 0 auto;z-index: 1001;width: 180px;">-->
    <!--          <el-switch-->
    <!--            v-model="electricityFeiLineRadio"-->
    <!--            active-text="年度"-->
    <!--            inactive-text="月度">-->
    <!--          </el-switch>-->
    <!--        </div>-->
    <!--        <common-line style="z-index: 1000" lineId='electricityFeiLine' :height='"280px"' :lineTitle='electricityFeiLineTitle' :legendData="electricityFeiLineLegendData" :xAxis="electricityFeiLineXAxis" :yAxis='electricityFeiLineYAxis' :series='electricityFeiLineSeries' />-->
    <!--      </div>-->

    <div class="visitor-over-view-line" style="margin-bottom: 0.12rem;padding: 0.12rem;position: relative;border-radius: 0.06rem;background-color: #fff;">
      <h2>充值统计</h2>
      <chart-time-select @getData="getRechargeStatistics" style="right: 0.14rem;top: 7.5%" />
      <common-line
        style="z-index: 1000"
        lineId='electricityPayLine'
        legendRight="478px"
        legendTop="2.7%"
        gridLeft="1.7%"
        :height='"1.73rem"'
        :legendData="electricityPayLegendData"
        :xAxis="electricityPayXAxis"
        :yAxis='electricityPayYAxis'
        :series='electricityPaySeries'
      />
    </div>

    <div class="electronic-over-view-line">
      <div class="electronic-over-view-line-left" style="justify-content: flex-start;flex-direction: column;display: block;border-radius: 0.06rem!important;">
        <div style="display: flex;justify-content: space-between">
          <div style="font-size: 0.1rem;color: #000;margin-bottom: 0.12rem;font-weight: 600">欠费住户 <span style="color: rgba(213, 9, 9, 1);">({{arrearsTotal}})</span></div>
          <!--            <el-pagination-->
          <!--              @current-change="arrearsCurrentChange"-->
          <!--              :page-size="arrearsPageSize"-->
          <!--              layout="prev, pager, next"-->
          <!--              :total="arrearsTotal">-->
          <!--            </el-pagination>-->
        </div>
        <!--          <el-table-->
        <!--            :data="arrearsTableData"-->
        <!--            style="width: 100%">-->
        <!--            <el-table-column-->
        <!--              label="住户名称">-->
        <!--              <template slot-scope="scope">-->
        <!--                <span>{{ scope.row.rentName }}</span>-->
        <!--              </template>-->
        <!--            </el-table-column>-->
        <!--            <el-table-column-->
        <!--              label="房间号">-->
        <!--              <template slot-scope="scope">-->
        <!--                <span>{{ scope.row.roomName }}</span>-->
        <!--              </template>-->
        <!--            </el-table-column>-->
        <!--            <el-table-column-->
        <!--              label="余额(元)">-->
        <!--              <template slot-scope="scope">-->
        <!--                <span>{{ scope.row.rentBalance }}</span>-->
        <!--              </template>-->
        <!--            </el-table-column>-->
        <!--            <el-table-column-->
        <!--              label="联系人"-->
        <!--              width="180">-->
        <!--              <template slot-scope="scope">-->
        <!--                <el-popover trigger="hover" placement="top">-->
        <!--                  <p v-if="scope.row.contractName" style="min-width: 180px;">{{ scope.row.contractName }} / {{ scope.row.contractPhone }} </p>-->
        <!--                  <p v-else>暂无联系人</p>-->
        <!--                  <div slot="reference" class="name-wrapper">-->
        <!--                    <span style="color: #00a0e6">联系人</span>-->
        <!--                    &lt;!&ndash;<el-tag size="medium">{{ scope.row.name }}</el-tag>&ndash;&gt;-->
        <!--                  </div>-->
        <!--                </el-popover>-->
        <!--              </template>-->
        <!--            </el-table-column>-->
        <!--          </el-table>-->
        <table-main
          :selection="false"
          :hasOperation="false"
          tableHeight="1.8rem"
          :tableHead="arrearsTableHead"
          :tableData="arrearsTableData"
          :total="arrearsTotal"
          :pageNum="arrearsPageNum"
          :pageSize="arrearsPageSize"
          @changePagination="arrearsCurrentChange"
          layoutText="total, prev, pager, next"
        />
      </div>
      <div class="electronic-over-view-line-right">
        <div style="display: flex;justify-content: space-between;margin-bottom: 0.12rem;text-align: left;border-radius: 0.06rem!important;">
          <div style="font-size: 0.1rem;color: #000;font-weight: 600">余额不足住户 ({{approachingPaymentTotal}})</div>
          <!--            <el-pagination-->
          <!--              @current-change="approachingPaymentCurrentChange"-->
          <!--              :page-size="approachingPaymentPageSize"-->
          <!--              layout="prev, pager, next"-->
          <!--              :total="approachingPaymentTotal">-->
          <!--            </el-pagination>-->
        </div>
        <!--          <el-table-->
        <!--            :data="approachingPaymentTableData"-->
        <!--            style="width: 100%">-->
        <!--            <el-table-column-->
        <!--              label="住户名称">-->
        <!--              <template slot-scope="scope">-->
        <!--                <span>{{ scope.row.rentName }}</span>-->
        <!--              </template>-->
        <!--            </el-table-column>-->
        <!--            <el-table-column-->
        <!--              label="房间号">-->
        <!--              <template slot-scope="scope">-->
        <!--                <span>{{ scope.row.roomName }}</span>-->
        <!--              </template>-->
        <!--            </el-table-column>-->
        <!--            <el-table-column-->
        <!--              label="余额(元)">-->
        <!--              <template slot-scope="scope">-->
        <!--                <span>{{ scope.row.rentBalance }}</span>-->
        <!--              </template>-->
        <!--            </el-table-column>-->
        <!--            <el-table-column-->
        <!--              label="联系人"-->
        <!--              width="180">-->
        <!--              <template slot-scope="scope">-->
        <!--                <el-popover trigger="hover" placement="top">-->
        <!--                  <p v-if="scope.row.contractName" style="min-width: 180px;">{{ scope.row.contractName }} / {{ scope.row.contractPhone }} </p>-->
        <!--                  <p v-else>暂无联系人</p>-->
        <!--                  <div slot="reference" class="name-wrapper">-->
        <!--                    <span style="color: #00a0e6">联系人</span>-->
        <!--                    &lt;!&ndash;<el-tag size="medium">{{ scope.row.name }}</el-tag>&ndash;&gt;-->
        <!--                  </div>-->
        <!--                </el-popover>-->
        <!--              </template>-->
        <!--            </el-table-column>-->

        <!--          </el-table>-->
        <table-main
          :selection="false"
          :hasOperation="false"
          tableHeight="1.8rem"
          :tableHead="arrearsTableHead"
          :tableData="approachingPaymentTableData"
          :total="approachingPaymentTotal"
          :pageNum="approachingPaymentPageNum"
          :pageSize="approachingPaymentPageSize"
          @changePagination="approachingPaymentCurrentChange"
          layoutText="total, prev, pager, next"
        />
      </div>
    </div>
    <!--    </el-tabs>-->

  </div>
</template>

<script>
import { api } from "../../api/ElectronicManagement";
import { errorHandler } from "../../../utils/errorHandler";
import ControllerPie from "../../../components/Echarts/Pie/Pie/controllerPie";
import AmmeterPie from "../../../components/Echarts/Pie/Pie/ammeterPie";
import ElectronicStackingBar from "../../../components/Echarts/Bar/StackingBar/ElectronicStackingBar";
import ElectronicMonthStackingBar from "../../../components/Echarts/Bar/StackingBar/ElectronicMonthStackingBar";
import CommonLine from "../../../components/Echarts/Line/commonLine";
import CommonRing from "../../../components/Echarts/Pie/Pie/commonRing";
import ChartTimeSelect from "../../../components/Echarts/ChartTimeSelect/newChartTimeSelect";
import TableMain from "../../../components/Table/TableMain";
import {debounce} from '../../../utils/util'

export default {
  components: {
    ChartTimeSelect,
    CommonRing,
    CommonLine,
    ElectronicMonthStackingBar,
    ElectronicStackingBar,
    AmmeterPie,
    ControllerPie,
    TableMain,
  },
  name: "over-view",
  data() {
    return {
      electricSceneList: [],
      // 楼栋
      buildingOnPage: "",
      buildingList: [],

      commonColorList: [
        "#5B9BD5",
        "#ED7D31",
        "#C2A753",
        "#4BB66E",
        "#FFA336",
        "#53A5BC"
      ],
      commonRingLegend: {
        left: "center",
        bottom: -5
      },
      electricQuantityTitle: "",
      electricQuantityInfo: [],
      electricFeiTitle: "",
      electricFeiInfo: [],

      // 欠费住户
      arrearsPageNum: 1,
     arrearsPageSize: 10,
      arrearsTotal: 0,
      arrearsTableHead: [
        {prop: 'rentName', label: '住户名称'},
        {prop: 'roomName', label: '房间号'},
        {prop: 'rentBalance', label: '余额(元)'},
        {prop: 'contractName', label: '联系人', isContractName: true},
      ],
      arrearsTableData: [],

     // 临近缴费住户
     approachingPaymentPageNum: 1,
     approachingPaymentPageSize: 10,
      approachingPaymentTotal: 0,
      approachingPaymentTableData: [],

      electricityRadio: false,
      electricityTitle: "场景电量统计",
      electricityLegendData: [],
      electricityXAxis: {
        type: "category",
        name: "日期",
        nameTextStyle: {
          color: '#000',
          fontSize: 'calc(100vw * 14/ 1920)',
        },
        boundaryGap: false,
        axisTick: {
          show: false, //是否显示刻度
        },
        axisLabel: {
          color: '#000',
          fontSize: 'calc(100vw * 14/ 1920)',
        },
        axisLine: {
          show: true,
          lineStyle: {
            type: 'dotted',
            color: 'rgba(50,50,50,0.4)',//坐标线的颜色
          }
        },
        data: []
      },
      legendTextStyle: {
        fontSize: 'calc(100vw * 14/ 1920)',
      },
      electricityYAxis: [
        {
          type: "value",
          name: "电量(度)",
          nameTextStyle: {
            color: '#000',
            fontSize: 'calc(100vw * 14/ 1920)',
          },
          axisTick: {
            show: false, //是否显示刻度
          },
          axisLabel: {
            color: '#000',
            fontSize: 'calc(100vw * 14/ 1920)',
          },
          splitLine: {
            lineStyle: {
              type: 'dotted',
              color: 'rgba(50,50,50,0.4)'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              type: 'dotted',
              color: 'rgba(50,50,50,0.4)',//坐标线的颜色
            }
          },
        }
      ],
      electricitySeries: [
        {
          name: "",
          type: "line",
          stack: "统计",
          // areaStyle: {},
          smooth: true,
          symbol: "circle",
          symbolSize: 5,
          sampling: "average",
          itemStyle: {
            color: "#00A0E6"
          },
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: "#00A0E6"
              },
              {
                offset: 1,
                color: "#ffe"
              }
            ])
          },
          data: []
        }
      ],

      electricityLevelTitle: "级别电量统计",
      electricityLevelLegendData: [],
      electricityLevelXAxis: {
        type: "category",
        name: "日期",
        nameTextStyle: {
          color: '#000',
          fontSize: 'calc(100vw * 14/ 1920)',
        },
        boundaryGap: false,
        axisTick: {
          show: false, //是否显示刻度
        },
        axisLabel: {
          color: '#000',
          fontSize: 'calc(100vw * 14/ 1920)',
        },
        axisLine: {
          show: true,
          lineStyle: {
            type: 'dotted',
            color: 'rgba(50,50,50,0.4)',//坐标线的颜色
          }
        },
        data: []
      },
      electricityLevelYAxis: [
        {
          type: "value",
          name: "电量(度)",
          nameTextStyle: {
            color: '#000',
            fontSize: 'calc(100vw * 14/ 1920)',
          },
          axisTick: {
            show: false, //是否显示刻度
          },
          axisLabel: {
            color: '#000',
            fontSize: 'calc(100vw * 14/ 1920)',
          },
          splitLine: {
            lineStyle: {
              type: 'dotted',
              color: 'rgba(50,50,50,0.4)'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              type: 'dotted',
              color: 'rgba(50,50,50,0.4)',//坐标线的颜色
            }
          },
        }
      ],
      electricityLevelSeries: [
        {
          name: "",
          type: "line",
          // stack: "统计",
          // areaStyle: {},
          smooth: true,
          symbol: "circle",
          symbolSize: 5,
          sampling: "average",
          itemStyle: {
            color: "#00A0E6"
          },
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: "#00A0E6"
              },
              {
                offset: 1,
                color: "#ffe"
              }
            ])
          },
          data: []
        }
      ],

      electricityFeiLineRadio: false,
      electricityFeiLineTitle: "电费统计",
      electricityFeiLineLegendData: [],
      electricityFeiLineXAxis: {
        type: "category",
        name: "日期",
        data: []
      },
      electricityFeiLineYAxis: [
        {
          type: "value",
          name: "金额(元)",
          splitLine: {
            show: false
          }
        }
      ],
      electricityFeiLineSeries: [
        {
          name: "",
          type: "line",
          stack: "统计",
          // areaStyle: {},
          smooth: true,
          symbol: "circle",
          symbolSize: 5,
          sampling: "average",
          itemStyle: {
            color: "#00A0E6"
          },
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: "#00A0E6"
              },
              {
                offset: 1,
                color: "#ffe"
              }
            ])
          },
          data: []
        }
      ],

      electricityPayRadio: false,
      electricityPayTitle: "充值统计",
      electricityPayLegendData: [],
      electricityPayXAxis: {
        type: "category",
        name: "日期",
        nameTextStyle: {
          color: '#000',
          fontSize: 'calc(100vw * 14/ 1920)',
        },
        boundaryGap: false,
        axisTick: {
          show: false, //是否显示刻度
        },
        axisLabel: {
          color: '#000',
          fontSize: 'calc(100vw * 14/ 1920)',
        },
        axisLine: {
          show: true,
          lineStyle: {
            type: 'dotted',
            color: 'rgba(50,50,50,0.4)',//坐标线的颜色
          }
        },
        data: []
      },
      electricityPayYAxis: [
        {
          type: "value",
          name: "金额(元)",
          nameTextStyle: {
            color: '#000',
            fontSize: 'calc(100vw * 14/ 1920)',
          },
          axisTick: {
            show: false, //是否显示刻度
          },
          axisLabel: {
            color: '#000',
            fontSize: 'calc(100vw * 14/ 1920)',
          },
          splitLine: {
            lineStyle: {
              type: 'dotted',
              color: 'rgba(50,50,50,0.4)'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              type: 'dotted',
              color: 'rgba(50,50,50,0.4)',//坐标线的颜色
            }
          },
        }
      ],
      electricityPaySeries: [],

      electricMeterTotalCount: 0,
      electricMeterOffCount: 0,

      electricManagerTotalCount: 0,
      electricManagerOffCount: 0,
      idList: ['electricityLevelLine', 'electricityLine', 'electricityPayLine']
    };
  },
  created() {
    this.getElectricMeterList();
    this.getElectricManagerList();
    this.getElectricSceneList();
    this.getBuildingList();
    this.getArrearsList();
    this.getApproachingPaymentList();

    this.getCurrentMonthEelectricity();
  },
  mounted() {
    window.addEventListener('resize', this.resizeChart)
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeChart)
  },
  methods: {
    resizeChart: debounce(function () {
      this.idList.map(v =>{
        let commonLine = this.$echarts.init(document.getElementById(v));
        commonLine.resize()
      })
    }, 100),

    // 电表
    getElectricMeterList() {
      let buildingCode = "";
      this.$axios
        .post(api.getElectricMeterDeviceOverview, {
          buildingCode: buildingCode
        })
        .then(res => {
          let data = res.data.data;
          this.electricMeterTotalCount = data.totalCount;
          this.electricMeterOffCount = data.offlineCount;
        })
        .catch(errorHandler("获取电表数据失败"));
    },
    // 集中器
    getElectricManagerList() {
      let buildingCode = "";
      this.$axios
        .post(api.getElectricControlDeviceOverview, {
          buildingCode: buildingCode
        })
        .then(res => {
          let data = res.data.data;
          this.electricManagerTotalCount = data.totalCount;
          this.electricManagerOffCount = data.offlineCount;
        })
        .catch(errorHandler("获取集中器数据失败"));
    },
    // 获取场景列表
    getElectricSceneList() {
      this.$axios
        .post(api.getElectricSceneList, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            this.electricSceneList = data;
          }
        })
        .catch(errorHandler("获取场景列表失败"));
    },
    // 获取楼栋列表
    getBuildingList() {
      this.$axios
        .post(api.getBuildingList, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            data.unshift({
              code: "",
              name: "全部"
            });
            this.buildingList = data;
          }
        })
        .catch(errorHandler("获取楼栋列表失败"));
    },

   // 欠费
   arrearsCurrentChange(val) {
      this.arrearsPageNum = val[0];
      this.arrearsPageSize = val[1];
     this.getArrearsList();
   },

    // 获取欠费住户
    getArrearsList() {
      this.$axios
        .post(api.getEnterprisePageByCondition, {
          enterpriseType: "1",
          pageNum: this.arrearsPageNum,
          pageSize: this.arrearsPageSize
        })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            this.arrearsTableData = data.list;
            this.arrearsTotal = data.total;
          }
        })
        .catch(errorHandler("获取欠费住户失败"));
    },

   // 欠费
   approachingPaymentCurrentChange(val) {
      this.approachingPaymentPageNum = val[0];
      this.approachingPaymentPageSize = val[1];
     this.getApproachingPaymentList();
   },

    // 获取临近缴费住户
    getApproachingPaymentList() {
      this.$axios
        .post(api.getEnterprisePageByCondition, {
          enterpriseType: "2",
          pageNum: this.approachingPaymentPageNum,
          pageSize: this.approachingPaymentPageSize
        })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            this.approachingPaymentTableData = data.list;
            this.approachingPaymentTotal = data.total;
          }
        })
        .catch(errorHandler("获取临近缴费住户失败"));
    },

    getCurrentMonthEelectricity() {
      this.$axios
        .get(`${api.getCurrentMonthEelectricity}`, {})
        .then(res => {
          let details = res.data.data.details;
          let electricQuantityInfo = [];
          let electricFeiInfo = [];
          let allQuantity = 0;
          let allMoney = 0;
          if (details) {
            details.map(v => {
              let electricQuantityObj = {
                name: v.electricSceneName,
                value: v.electricSceneData
              };
              let electricFeiObj = {
                name: v.electricSceneName,
                value: v.electricSceneMoney
              };
              allQuantity = parseFloat(
                allQuantity + v.electricSceneData
              ).toFixed(2);
              allMoney = parseFloat(allMoney + v.electricSceneMoney).toFixed(2);
              electricQuantityInfo.push(electricQuantityObj);
              electricFeiInfo.push(electricFeiObj);
            });
          }
          this.electricQuantityInfo = electricQuantityInfo;
          this.electricQuantityTitle = `${res.data.data.totalEelectricity && String(res.data.data.totalEelectricity).indexOf('.') > -1 ? res.data.data.totalEelectricity.toFixed(0) : res.data.data.totalEelectricity}`;
          this.electricFeiInfo = electricFeiInfo;
          this.electricFeiTitle = `${res.data.data.totalMoney && String(res.data.data.totalMoney).indexOf('.') > -1 ? res.data.data.totalMoney.toFixed(0) : res.data.data.totalMoney}`;
        })
        .catch(errorHandler("获取数据失败"));
    },

    getRechargeStatistics(type, startTime, endTime) {
      this.$axios
        .post(`${api.getElectricRechargeStatistics}`, {
          startTime: startTime || "",
          endTime: endTime || "",
          timeType: type || "DAY"
        })
        .then(res => {
          let data = res.data.data;
          let xData = [];
          let seriesData = [];
          data.map(v => {
            seriesData.push(v.electricityMoney);
            xData.push(v.time);
          });
          this.electricityPayXAxis.data = xData;
          this.electricityPaySeries = [
            {
              name: "",
              type: "line",
              stack: "统计",
              // areaStyle: {},
              smooth: true,
              symbol: "circle",
              symbolSize: 5,
              sampling: "average",
              itemStyle: {
                color: "#0A84FF",
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "rgba(10, 132, 255, 0.40)"
                  },
                  {
                    offset: 1,
                    color: "rgba(10, 132, 255, 0)"
                  }
                ])
              },
              data: seriesData
            }
          ];
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 场景电量统计
    getEelectricityStatistics(type, startTime, endTime) {
      let colorList = [
        "#0A84FF",
        "#32D74B",
        "#FF9F0A",
        "#FF2D55",
        "#5E5CE6",
        "#FFD60A",
        "#FF453A",
        "#64D2FF",
        "#BF5AF2",
        "#D4DEEC",
      ];
      let gradientColorList = [
        ["rgba(10, 132, 255, 0.40)", "rgba(10, 132, 255, 0)"],
        ["rgba(50, 215, 75, 0.40)", "rgba(50, 215, 75, 0)"],
        ["rgba(255, 159, 10, 0.40)", "rgba(255, 159, 10, 0)"],
        ['rgba(255, 45, 85, 0.40)', 'rgba(255, 45, 85, 0)'],
        ["rgba(94, 92, 230, 0.40)", "rgba(94, 92, 230, 0)"],
        ["rgba(255, 214, 10, 0.40)", "rgba(255, 214, 10, 0)"],
        ["rgba(255, 69, 58, 0.40)", "rgba(255, 69, 58, 0)"],
        ["rgba(100, 210, 255, 0.40)", "rgba(100, 210, 255, 0)"],
        ["rgba(191, 90, 242, 0.40)", "rgba(191, 90, 242, 0)"],
        ['rgba(212, 222, 236, 0.40)', 'rgba(212, 222, 236, 0)'],
      ];
      this.$axios
        .post(`${api.getEelectricityStatistics}`, {
          startTime: startTime || "",
          endTime: endTime || "",
          timeType: type || "DAY"
        })
        .then(res => {
          let data = res.data.data;
          let xData = [];
          let electricitySeriesData = [];
          let electricityFeiLineSeriesData = [];
          let electricityNameData = [];
          let electricitySeries = [];
          let electricityFeiLineSeries = [];
          this.electricSceneList.map(v => {
            electricityNameData.push(v.name);
          });
          setTimeout(() => {
            data.map((v, i) => {
              electricityNameData.map(
                (electricityName, electricityNameIndex) => {
                  if (!electricitySeriesData[electricityNameIndex]) {
                    electricitySeriesData[electricityNameIndex] = [];
                  }
                  if (!electricityFeiLineSeriesData[electricityNameIndex]) {
                    electricityFeiLineSeriesData[electricityNameIndex] = [];
                  }
                  if (v.details) {
                    v.details.map((detail, detailIndex) => {
                      if (!electricitySeriesData[electricityNameIndex][i]) {
                        electricitySeriesData[electricityNameIndex][i] = 0;
                        electricityFeiLineSeriesData[electricityNameIndex][
                          i
                          ] = 0;
                      }
                      if (detail.electricSceneName === electricityName) {
                        electricitySeriesData[electricityNameIndex][i] =
                          detail.electricSceneData;
                        electricityFeiLineSeriesData[electricityNameIndex][i] =
                          detail.electricSceneMoney;
                      }
                    });
                  } else {
                    electricitySeriesData[electricityNameIndex].push(0);
                    electricityFeiLineSeriesData[electricityNameIndex].push(0);
                  }
                }
              );
              if (type === 1) {
                let dateArr = v.billTime.split("-");
                let showData = `${dateArr[1]}-${dateArr[2]}`;
                xData.push(showData);
              } else {
                xData.push(v.billTime);
              }
            });
            if (data.length > 0) {
              console.log(electricityNameData, 'electricityNameData')
              for (let k = 0; k < electricityNameData.length; k++) {
                console.log(k%10, 'k%10')
                electricitySeries[k] = {
                  name: electricityNameData[k],
                  type: "line",
                  // stack: "统计",
                  // areaStyle: {},
                  smooth: true,
                  symbol: "circle",
                  symbolSize: 5,
                  sampling: "average",
                  itemStyle: {
                    color: k > 9 ? colorList[k%10] : colorList[k]
                  },
                  areaStyle: {
                    color: new this.$echarts.graphic.LinearGradient(
                      0,
                      0,
                      0,
                      1,
                      [
                        {
                          offset: 0,
                          color: k > 9 ? gradientColorList[k%10][0] : gradientColorList[k][0]
                        },
                        {
                          offset: 1,
                          color: k > 9 ? gradientColorList[k%10][1] : gradientColorList[k][1]
                        }
                      ]
                    )
                  },
                  data: electricitySeriesData[k]
                };
                // electricityFeiLineSeries[k] = {
                //   name: electricityNameData[k],
                //   type: "line",
                //   stack: electricityNameData[k],
                //   // areaStyle: {},
                //   smooth: true,
                //   symbol: "circle",
                //   symbolSize: 5,
                //   sampling: "average",
                //   itemStyle: {
                //     color: colorList[k]
                //   },
                //   areaStyle: {
                //     color: new this.$echarts.graphic.LinearGradient(
                //       0,
                //       0,
                //       0,
                //       1,
                //       [
                //         {
                //           offset: 0,
                //           color: colorList[k]
                //         },
                //         {
                //           offset: 1,
                //           color: "#ffe"
                //         }
                //       ]
                //     )
                //   },
                //   data: electricityFeiLineSeriesData[k]
                // };
              }
            }
            setTimeout(() => {
              this.electricityXAxis.data = xData;
              // this.electricityFeiLineXAxis.data = xData;
              this.electricitySeries = electricitySeries;
              // this.electricityFeiLineSeries = electricityFeiLineSeries;
              this.electricityLegendData = electricityNameData;
              // this.electricityFeiLineLegendData = electricityNameData;
            }, 50);
          }, 50);
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 级别电量统计
    getEelectricityLevleStatistics(type, startTime, endTime) {
      let colorList = [
        "#FF0A8E",
        "#8438FF",
        "#FF8C38",
        "#0A84FF",
        "#32D74B",
      ];
      let gradientColorList = [
        ["rgba(255, 10, 142, 0.40)", "rgba(255, 10, 142, 0)"],
        ["rgba(132, 56, 255, 0.40)", "rgba(132, 56, 255, 0)"],
        ["rgba(255, 140, 56, 0.40)", "rgba(255, 140, 56, 0)"],
        ["rgba(10, 132, 255, 0.40)", "rgba(10, 132, 255, 0)"],
        ["rgba(50, 215, 75, 0.40)", "rgba(50, 215, 75, 0)"],
      ];
      this.$axios
        .post(`${api.getElectricRechargeStatistics}`, {
          startTime: startTime || "",
          endTime: endTime || "",
          timeType: type || "DAY"
        })
        .then(res => {
          let data = res.data.data;
          let xData = [];
          let electricitySeriesData = [];
          let electricityNameData = ["一级", "二级", "三级", "四级", "五级"];
          let electricitySeries = [];

          setTimeout(() => {
            data.map((v, i) => {
              electricityNameData.map(
                (electricityName, electricityNameIndex) => {
                  if (!electricitySeriesData[electricityNameIndex]) {
                    electricitySeriesData[electricityNameIndex] = [];
                  }
                  if (v.electricityDetails) {
                    v.electricityDetails.map((detail, detailIndex) => {
                      if (!electricitySeriesData[electricityNameIndex][i]) {
                        electricitySeriesData[electricityNameIndex][i] = 0;
                      }
                      if (detail.level === electricityNameIndex + 1) {
                        electricitySeriesData[electricityNameIndex][i] =
                          detail.electricityNumber;
                      }
                    });
                  } else {
                    electricitySeriesData[electricityNameIndex][i] = 0;
                  }
                }
              );
              xData.push(v.time);
            });
            if (data.length > 0) {
              for (let k = 0; k < electricityNameData.length; k++) {
                electricitySeries[k] = {
                  name: electricityNameData[k],
                  type: "line",
                  // stack: "统计", //去掉可以让多条折现图不重合
                  // areaStyle: {},
                  smooth: true,
                  symbol: "circle",
                  symbolSize: 5,
                  sampling: "average",
                  itemStyle: {
                    color: colorList[k]
                  },
                  areaStyle: {
                    color: new this.$echarts.graphic.LinearGradient(
                      0,
                      0,
                      0,
                      1,
                      [
                        {
                          offset: 0,
                          color: gradientColorList[k][0]
                        },
                        {
                          offset: 1,
                          color: gradientColorList[k][1]
                        }
                      ]
                    )
                  },
                  data: electricitySeriesData[k]
                };
              }
            }
            this.electricityLevelLegendData = electricityNameData;
            this.electricityLevelXAxis.data = xData;
            this.electricityLevelSeries = electricitySeries;
          }, 50);
        })
        .catch(errorHandler("获取数据失败"));
    }
  },

  watch: {}
};
</script>

<style lang="less" scoped>
.electronic-over-view {
  padding: 0.16rem 0.12rem 0.16rem 0.16rem;
  background-color: rgba(240, 240, 247, 1);
  margin: 0;
  h2 {
    position: absolute;
    top: 6.2%;
    font-size: 0.1rem;
    text-align: left;
    z-index: 1001;
  }
  .electronic-over-view-line {
    display: flex;
    justify-content: space-between;
    .electronic-person-count-box {
      width: 1.3rem;
      height: 0.72rem;
      padding: 0.16rem 0.12rem;
      border-radius: 10px;
      color: #ffffff;
      background-color: #00a0e6;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border: unset;
      box-shadow: unset;
      img {
        width: 0.28rem;
        height: 0.3rem;
      }
      i {
        width: 30%;
        font-size: 48px;
      }
      .electronic-person-count-box-info {
        width: 70%;
        text-align: left;
        .electronic-person-count {
          font-size: 0.17rem;
          font-weight: 500;
          word-wrap: break-word;
          .electronic-person-count-unit {
            font-size: 0.08rem;
          }
        }
        .electronic-person-tip {
          font-size: 0.09rem;
          margin-bottom: 0.08rem;
        }
      }
    }
    .electronic-over-view-line-left {
      width: 49%;
      padding: 0.12rem 0.12rem 0 0.12rem;
      background-color: #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      overflow: hidden;
      box-shadow: unset!important;
      border: unset!important;
      /deep/.all-table-class .el-table tbody .cell {
        color: #D50909;
      }
    }
    .electronic-over-view-line-right {
      width: 49%;
      padding: 0.12rem 0.12rem 0 0.12rem;
      border-radius: 0.06rem!important;
      background-color: #fff;
      display: unset;
      //justify-content: space-between;
      //align-items: center;#606266
      overflow: hidden;
      box-shadow: unset!important;
      border: unset!important;
      /deep/.all-table-class .el-table tbody .cell {
        color: #606266;
      }
    }

    //.el-table {
    //  thead {
    //    th {
    //      padding: 6px 0;
    //      text-align: center;
    //      color: #666666;
    //      background-color: #eff1f5;
    //    }
    //  }
    //  tbody {
    //    td {
    //      padding: 6px 0;
    //      text-align: center;
    //      color: #ff0000;
    //    }
    //  }
    //}
    //
    //.el-pagination {
    //  padding: 0;
    //}
  }
  /deep/.chart-time-select {
    margin: 0;
    width: unset;
    left: unset;
  }
  /deep/.chart-time-select1 {
    margin: 0;
    width: unset;
    left: unset;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/ElectronicManagement/OverView/OverView.vue